import * as React from "react";
import { useEffect, useState } from "react";

import { CoverSize, coverSrc } from "../../lib/covers";
import Work from "../../types/Work";

/**
 * A work's cover in a 2:3 frame: the real image over the title on its
 * type's dye, which shows if there's no image or it doesn't load.
 */
const Cover: React.FC<{
  work: Work;
  size?: CoverSize;
  className?: string;
}> = ({ work, size = "card", className }) => {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [work.coverUrl]);
  const title = work.title;
  return (
    <span
      className={`cover cover-${work.workType}${className ? ` ${className}` : ""}`}
      aria-hidden="true"
    >
      <span className="cover-title">{title}</span>
      {work.coverUrl && !failed && (
        <img
          src={coverSrc(work.coverUrl, size)}
          alt=""
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
        />
      )}
    </span>
  );
};

export default Cover;
